import { atom } from 'jotai';
import { snackbarColor } from '@/enums';
import type { SnackbarType } from '@/types';

export const snackbarAtom = atom<SnackbarType>({
    open: false,
    message: '',
    severity: snackbarColor.error,
    vertical: 'bottom',
    horizontal: 'center',
});
